export function buildResourcesByStrategyIdQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Resources.Queries.ResourcesByStrategyIdQueryV1, TCh.Domain.Quest',
		'StrategyId': strategyId,
		'WorkspaceId': workspaceId,
	}
}


export function buildResourceUnitCostsQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Resources.Queries.ResourceUnitCostsQueryV1, TCh.Domain.Quest',
		'StrategyId': strategyId,
		'WorkspaceId': workspaceId,
	}
}

export function buildResourceCapacityPageQueryV1(workspaceId: number, strategyId: string, resourceId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Resources.Queries.ResourceCapacityPageQueryV1, TCh.Domain.Quest',
		'StrategyId': strategyId,
		'WorkspaceId': workspaceId,
		'ResourceId': resourceId,
	}
}




